exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsvg[data-v-36f03433] {\n  display: inline-block;\n  vertical-align: middle;\n  pointer-events: none;\n}\n", ""]);

// exports
